import "bootstrap/dist/css/bootstrap.min.css";
import "./src/styles/global.css";

import React from "react";
import Layout from "./src/components/Layout";

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>;

export const shouldUpdateScroll = ({ routerProps }) => {
  if (routerProps.location.hash) {
    return true;
  }

  return [0, 0];
};
